export enum FiBooleanOperator {
    Or = 0,
    And = 1,
    Not = 2,
}
